import { render, staticRenderFns } from "./screenTab.vue?vue&type=template&id=28d8cd39&scoped=true&"
import script from "./screenTab.vue?vue&type=script&lang=js&"
export * from "./screenTab.vue?vue&type=script&lang=js&"
import style0 from "./screenTab.vue?vue&type=style&index=0&id=28d8cd39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d8cd39",
  null
  
)

export default component.exports